module.exports = __webpack_public_path__ + "img/03-more-button.b00afdd8.png";